<selfai-platform-data-list-view
  [layoutTypes]="['table']"
  [showEntityIcon]="true"
  [columns]="columns"
  [actions]="actions$ | async"
  [groupActions]="groupActions$ | async"
  [emptyMessage]="'shell.board.filter.ui.search-all.nodata' | translate"
>
</selfai-platform-data-list-view>
